
$(function () {
    $('a[data-modal-link]')
        .removeAttr('data-modal-link')
        .attr('target', '_blank');
});
